import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Collapse, Nav } from 'reactstrap';
import { LinksCategory } from './LinksCategory';
import { Links } from './Links';
import { SidebarGroup } from './SidebarGroup';

const groupRoutes = routes => routes.reduce((groups, route) => {
  const groupId = route.group || 'ungrouped';
  const existingGroup = groups.find(group => group.id === groupId);

  if (existingGroup) {
    existingGroup.routes.push(route);
    return groups;
  }

  return [...groups, { id: groupId, routes: [route] }];
}, []);

class ScrollBarInner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      ...this.getCollapseStates(props.routes)
    };
  }

  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };

  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (
        routes[i].subPaths && routes[i].subPaths.length
      ) {
        for (let j = 0; j < routes[i].subPaths.length; j++){
          if (window.location.href.indexOf(routes[i].subPaths[j]))
            return true;
        }
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };

  renderRoute = (prop, key) => {
    if (prop.redirect) {
      return null;
    }

    if (prop.collapse) {
      return (
        <LinksCategory
          {...prop}
          location={this.props.location}
          key={key}
          index={key}
          expanded={this.state[prop.state]}
          onClick={e => {
            e.preventDefault();
            this.setState({ [prop.state]: !this.state[prop.state] });
          }}
        />
      );
    }

    return <Links
      {...prop}
      location={this.props.location}
      key={key}
      index={key}
      sidenavOpen={this.props.sidenavOpen}
    />;
  };

  render() {
    const { routes } = this.props;
    return (
      <div className="navbar-inner" id="sidebar-navigation">
        <Collapse navbar isOpen={false}>
          {groupRoutes(routes).map(group => group.id === 'ungrouped' ? (
            <Nav navbar key={group.id}>
              {group.routes.map(route => this.renderRoute(route, routes.indexOf(route)))}
            </Nav>
          ) : (
            <SidebarGroup id={group.id} key={group.id}>
              <Nav navbar>
                {group.routes.map(route => this.renderRoute(route, routes.indexOf(route)))}
              </Nav>
            </SidebarGroup>
          ))}
        </Collapse>
      </div>
    );
  }
}

ScrollBarInner.defaultProps = {
  routes: [{}],
  sidenavOpen: true,
};

ScrollBarInner.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  sidenavOpen: PropTypes.bool,
};

export { ScrollBarInner, groupRoutes };
